// Generated by purs version 0.11.7
"use strict";
var Data_Function = require("../Data.Function");
var Data_Lens = require("../Data.Lens");
var Data_Lens_Lens = require("../Data.Lens.Lens");
var Data_Record = require("../Data.Record");
var Data_Symbol = require("../Data.Symbol");
var Prelude = require("../Prelude");
var prop = function (dictIsSymbol) {
    return function (dictRowCons) {
        return function (dictRowCons1) {
            return function (l) {
                return function (dictStrong) {
                    return Data_Lens_Lens.lens(Data_Record.get(dictIsSymbol)(dictRowCons)(l))(Data_Function.flip(Data_Record.set(dictIsSymbol)(dictRowCons)(dictRowCons1)(l)))(dictStrong);
                };
            };
        };
    };
};
module.exports = {
    prop: prop
};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Lens.Record/index.js
// module id = 566
// module chunks = 0